module.exports = __webpack_public_path__ + "img/5.71635b92.svg";